import { memo } from "react";

import { CarouselItem } from "./Carousel";
export default memo(CarouselItem);
